import { render, staticRenderFns } from "./FirmConfigView.vue?vue&type=template&id=2549e2a4&"
import script from "./FirmConfigView.vue?vue&type=script&lang=js&"
export * from "./FirmConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports